var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"freehand-workflow-comment"},[_c('path',{staticClass:"prevent-zoom",style:(_setup.style),attrs:{"d":_setup.curve},on:{"mouseover":_setup.onMouseOver,"mousedown":function($event){$event.preventDefault();return _setup.onClick.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }